import type { PiletApi } from '@chess/platform-web';
import { CHESS_API } from '@chess/api-chess';
import { createChessJs } from '@chess/api-chess/chessjs';

// Provides `chess`, the rules of the game, with chess.js underneath. The
// implementation lives in @chess/api-chess/chessjs, so tests and headless
// code can use the same rules without the platform; this plugin only
// registers it, and everything else speaks @chess/api-chess.
export function setup(app: PiletApi) {
  app.registerApi(CHESS_API, createChessJs());
}
